import * as React from 'react';

import { cn } from '@/lib/utils';

type InputProps = {
    label?: string;
    error?: string;
} & React.ComponentProps<'input'>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, label, error, name, type, ...props }, ref) => {
        return (
            <div className={cn('w-full flex flex-col gap-2', className)}>
                {label && (
                    <label htmlFor={name} className="text-sm w-full">
                        {label}
                        <span className="text-blue-600 text-sm ml-1">*</span>
                    </label>
                )}

                <input
                    type={type}
                    className={cn(
                        'flex h-10 w-full rounded-md border bg-neutral-750 inputs  border-neutral-650 px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                    )}
                    name={name}
                    ref={ref}
                    {...props}
                />
                {error && <p className="text-sm text-red-500">{error}</p>}
            </div>
        );
    },
);
Input.displayName = 'Input';

export { Input };
